import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { selectClasses } from "@mui/material/Select";
import type { MenuProps } from "@mui/material/Menu";
import type { SxProps, Theme } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import { pickersOutlinedInputClasses } from "@mui/x-date-pickers/PickersTextField";
import { useState } from "react";

export type InlineInputState = "editing" | "not-editing" | "readonly";

export const useInlineInputState = (isReadonly: boolean = false) => {
  const [isEditing, setIsEditing] = useState(false);

  const inputState: InlineInputState = isReadonly ? "readonly" : isEditing ? "editing" : "not-editing";

  return { inputState, setIsEditing };
};

const nonEditingAndReadonly: SxProps<Theme> = {
  [`& fieldset`]: { borderColor: "transparent !important" },
  [`& .${selectClasses.icon}, .${autocompleteClasses.popupIndicator}`]: {
    visibility: "hidden",
  },
};
export type InlineInputStateStyles = Record<InlineInputState, SxProps<Theme>>;
export const inlineInputStateStyles: InlineInputStateStyles = {
  "editing": {},
  "not-editing": {
    boxShadow: "none !important",
    [`&.${outlinedInputClasses.root}:hover`]: {
      bgcolor: theme => theme.palette.action.hover,
      boxShadow: "none",
      cursor: "pointer",
    },
    [`&.${outlinedInputClasses.root} > fieldset`]: { boxShadow: "none !important" },
    [`& .${outlinedInputClasses.input}`]: { cursor: "pointer" },
    ...nonEditingAndReadonly,
  },
  "readonly": {
    [`&.${outlinedInputClasses.root} *`]: { cursor: "auto !important" },
    ...nonEditingAndReadonly,
  },
};

export const menuProps: Partial<MenuProps> = { sx: { maxHeight: "25rem", maxWidth: "30rem" } };

const pickerBorderless: SxProps<Theme> = {
  [`& .${pickersOutlinedInputClasses.notchedOutline}`]: { border: "0 !important" },
};

export const pickerInlineInputStateStyles: InlineInputStateStyles = {
  "editing": {},
  "not-editing": {
    "boxShadow": "none !important",
    "cursor": "pointer",
    "&:hover": { bgcolor: theme => theme.palette.action.hover, cursor: "pointer" },
    ...pickerBorderless,
  },
  "readonly": { cursor: "auto", ...pickerBorderless },
};
